<template>
  <div class="Legend mb-3">
    <div 
      v-if="getLoadedStatus"
      class="Legend__title d-flex pl-3 ml-3">
      <span class="align-self-center">
        LEGENDA
      </span>
    </div>
    <div v-if="getLoadedStatus">
      <ul class="m-0 p-0 pl-3 ml-3 mb-3 list-unstyled">
        <li class="d-flex my-3 mr-3 align-items-center">
          <span></span> 
          <span class="mx-2 flex-grow-1">Alle lagen</span>
          <ToggleSwitch class="m-0" v-model="all" />
        </li>

        <li 
          v-for="layer in activeLayers" 
          :key="layer.id"
          class="d-flex my-3 mr-3 align-items-center">
          <span><img :src="layer.image" :width="layer.imageWidth" /></span> 
          <span class="mx-2 flex-grow-1">{{ layer.label }}</span>
          <ToggleSwitch class="m-0" v-model="layer.visible" />
        </li>
      </ul>
    </div>
    <div 
      v-if="getLoadedStatus"
      class="Legend__subtitle d-flex pl-3 ml-3 mt-5">
      <span class="align-self-center">
        Prognose in aantal per dag
      </span>
    </div>
    <div v-if="getLoadedStatus">
      <ul class="m-0 p-0 pl-3 ml-3 mb-3 list-unstyled">
        <li class="d-flex my-2 mr-3 align-items-center">
          <span>
            <Hexagon style="position: absolute" color="#f6f6f4" />
            <Hexagon color="hsl(213, 55%, 75%)" :opacity="opacity" />
          </span> 
          <span class="mx-2 flex-grow-1">0 t/m 6 EV's</span>
        </li>
        <li class="d-flex my-2 mr-3 align-items-center">
          <span>
            <Hexagon style="position: absolute" color="#f6f6f4" />
            <Hexagon color="hsl(213, 65%, 60%)" :opacity="opacity" />
          </span> 
          <span class="mx-2 flex-grow-1">> 6 t/m 12 EV's</span>
        </li>
        <li class="d-flex my-2 mr-3 align-items-center">
          <span>
            <Hexagon style="position: absolute" color="#f6f6f4" />
            <Hexagon color="hsl(213, 80%, 50%)" :opacity="opacity" />
          </span> 
          <span class="mx-2 flex-grow-1">> 12 t/m 24 EV's</span>
        </li>
        <li class="d-flex my-2 mr-3 align-items-center">
          <span>
            <Hexagon style="position: absolute" color="#f6f6f4" />
            <Hexagon color="hsl(213, 95%, 20%)" :opacity="opacity" />
          </span> 
          <span class="mx-2 flex-grow-1">> 24 EV's</span>
        </li>
        <li class="d-flex my-2 mr-3 align-items-center">
          <span>
            <Hexagon style="position: absolute" color="#f6f6f4" />
            <Hexagon color="hsl(23, 100%, 42%)" :opacity="opacity" />
          </span> 
          <span class="mx-2 flex-grow-1">Geselecteerd</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import Hexagon from 'atom/Hexagon'
import ToggleSwitch from 'molecule/form/ToggleSwitch'

import { icon, image } from 'helper/assets'
import { mapGetters } from 'vuex'

export default {
  components: {
    ToggleSwitch, Hexagon
  },
  data() {
    return {
      layers: [
        {
          id: 'suggestion',
          label: 'Voorgestelde laadpalen',
          image: icon({ name: 'chargingstation-gemeente.svg' }),
          imageWidth: 20,
          visible: true,
          active: false
        },
        {
          id: 'plannedchargingpoints',
          label: 'Geplande laadpalen',
          image: icon({ name: 'chargingstation.svg' }),
          imageWidth: 20,
          visible: true,
          active: false
        },
        {
          id: 'in-progress',
          label: 'Wordt gerealiseerd',
          image: icon({ name: 'chargingstation-inprogress.svg' }),
          imageWidth: 20,
          visible: true,
          active: false
        },
        {
          id: 'chargingpoints',
          label: 'Bestaande laadpalen',
          image: icon({ name: 'chargingstation-bestaand.svg' }),
          imageWidth: 20,
          visible: true,
          active: false
        },
        {
          id: 'fuelstations',
          label: 'Pompstation',
          image: icon({ name: 'fuelpump.svg' }),
          imageWidth: 20,
          visible: true,
          active: false
        },
        {
          id: 'pplusr',
          label: 'Park + Ride',
          image: icon({ name: 'Parkandride-icon.svg' }),
          imageWidth: 20,
          visible: true,
          active: false
        },
        {
          id: 'ls',
          label: 'Laagspanning',
          image: image({ name: 'ls.png' }),
          imageWidth: 15,
          visible: true,
          active: false,
          layers: ['ls', 'ovkasten', 'ovkasten-labels']
        },
        {
          id: 'parking',
          label: 'Parkeervak',
          image: image({ name: 'parkeren.png' }),
          imageWidth: 15,
          visible: true,
          active: false
        },
        {
          id: 'trees',
          label: 'Boom',
          image: image({ name: 'boom.png' }),
          imageWidth: 15,
          visible: true,
          active: false
        },
        {
          id: 'visitorlocations',
          label: 'Bezoekerslocatie',
          image: image({ name: 'locaties.png' }),
          imageWidth: 15,
          visible: true,
          active: false
        },
        {
          id: 'border',
          label: 'Gebiedsgrens',
          image: image({ name: 'border.png' }),
          imageWidth: 15,
          visible: true,
          active: false
        }
      ],
      opacity: 0.7
    }
  },
  computed: {
    ...mapGetters('map', [
      'getLoadedStatus'
    ]),
    ...mapGetters('config', {
      layerConfig: 'layers'
    }),
    // Toggle all layers
    all: {
      get() {
        return ! this.layers.some(layer => layer.active && !layer.visible)
      },
      set(value) {
        this.layers.forEach(layer => layer.visible = value)
      }
    },
    activeLayers() {
      return this.layers.filter(layer => layer.active)
    }
  },
  watch: {
    // Handle toggling of layers
    layers: {
      handler: function(layers) {
        layers
          .filter(layer => layer.active)
          .forEach(layer => {
            if (layer.layers) {
              layer.layers.forEach(layerName => {
                this.toggleLayer({ layer: layerName, value: layer.visible })
              })
            } else {
              this.toggleLayer({ layer: layer.id, value: layer.visible })
            }
          })
      }, deep: true
    },
    // Bind zoom watcher to update the legend opacity accordingly
    getLoadedStatus: function(value) {
      if (value) {
        this.setHexoganOpacityFromZoom({ zoom : this.$store.map.getZoom() })
        this.$store.map.on('zoom', (value) => {
          this.setHexoganOpacityFromZoom({ zoom: value.target.getZoom() })
        })
      }
    }
  },
  created() {
    this.layers.forEach(layer => {
      if (this.layerConfig[layer.id] && this.layerConfig[layer.id].active) {
        layer.active = true
      }
      // 
      else if (['suggestion', 'in-progress'].includes(layer.id) && this.layerConfig.plannedchargingpoints.active) {
        layer.active = true
      }
    })
  },
  methods: {
    icon,
    image,
    toggleLayer({ layer, value }) {
      if (this.$store.map && this.$store.map.getLayer(layer)) {

        let state

        // The charging point and planned charging point legend toggles have an unique effect
        if (['plannedchargingpoints', 'chargingpoints', 'in-progress', 'suggestion'].includes(layer)) {
          
          let suggestion = this.layers.find(layer => layer.id === 'suggestion')
          let plannedchargingpoints = this.layers.find(layer => layer.id === 'plannedchargingpoints')
          let inprogress = this.layers.find(layer => layer.id === 'in-progress')
          let chargingpoints = this.layers.find(layer => layer.id === 'chargingpoints')

          let visibleState = 0.8
          let invisibleState = 0

          state = ["match", // visibility state based filter
              ['get', 'status'], 
              "suggestion", suggestion.visible ? visibleState : invisibleState,
              "definitive", plannedchargingpoints.visible ? visibleState : invisibleState,
              "in-progress", inprogress.visible ? visibleState : invisibleState,
              "realized", chargingpoints.visible ? visibleState : invisibleState,
              visibleState]

          state = [ // transition based on zoom
            "interpolate",
            ["linear"],
            ["zoom"],
            10,
            0,
            10.2,
            state
          ] 

          this.$store.map.setPaintProperty('plannedchargingpoints', 'icon-opacity', state)
        }
        
        if (layer !== 'plannedchargingpoints') {
          state = value 
            ? 'visible'
            : 'none'
          this.$store.map.setLayoutProperty(layer, 'visibility', state) 
        }
      }
    },
    setHexoganOpacityFromZoom({ zoom }) {
      if (zoom < 10) {
        this.opacity = 0.7
      } else if (zoom > 13) {
        this.opacity = 0.4
      } else {
        this.opacity = 0.7 - (((zoom - 10) / 3) * 0.3)
      }
    }
  }
}
</script>

<style lang="scss">

.Legend {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);

  &__title {
    height: 60px;
  }
  &__subtitle {
    height: 30px
  }
  ul li span:first-child {
    width: 20px;
  }
  ul li {
    line-height: 1
  }
}

</style>
